var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.myshow,
          expression: "myshow",
        },
      ],
      staticClass: "mt-auto bg-white",
    },
    [
      _c("div", { staticClass: "container" }, [
        _vm.shop
          ? _c(
              "div",
              {
                staticClass:
                  "footerContent d-flex justify-content-between flex-wrap",
              },
              [
                _c("div", { staticClass: "blockFooter about" }, [
                  _c("h4", [_vm._v("Nous découvrir")]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    [
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: { title: "Accueil", href: _vm.shop.ShopId },
                          },
                          [_vm._v("Accueil")]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.orderedPages, function (page) {
                        return _c("li", { key: page.id }, [
                          page.footer_position != -1
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    title: page.title,
                                    href:
                                      _vm.shop.ShopId +
                                      "/page/" +
                                      page.id +
                                      "/" +
                                      _vm.dashify(page.title),
                                  },
                                },
                                [_vm._v(_vm._s(page.title))]
                              )
                            : _vm._e(),
                        ])
                      }),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            attrs: {
                              title: "Nous contacter",
                              href: _vm.shop.ShopId + "/contact",
                            },
                          },
                          [_vm._v("Nous contacter")]
                        ),
                      ]),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "blockFooter infos" }, [
                  _c("h4", [_vm._v("Informations")]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", [
                      _c(
                        "a",
                        {
                          attrs: {
                            title: "Conditions générales de vente",
                            href: _vm.shop.ShopId + "/cgv",
                          },
                        },
                        [_vm._v("Conditions générales")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          attrs: {
                            title: "Confidentialité & cookies - RGPD",
                            href: _vm.shop.ShopId + "/rgpd",
                          },
                        },
                        [_vm._v("Confidentialité")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          attrs: {
                            title: "Plan du site",
                            href: _vm.shop.ShopId + "/sitemap",
                          },
                        },
                        [_vm._v("Plan du site")]
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm.shop.info.iPhoneApp || _vm.shop.info.AndroidApp
                  ? _c("div", { staticClass: "blockFooter apps" }, [
                      _c("h4", [_vm._v("Téléchargez l'application")]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center",
                        },
                        [
                          _vm.shop.info.iPhoneApp
                            ? _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      title: "Télecharger dans l'App Store",
                                      href:
                                        "https://" + _vm.shop.info.iPhoneApp,
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        alt: "Télecharger dans l'App Store",
                                        src: require("../_design_files/img/download-ios.png"),
                                        width: "173",
                                        height: "58",
                                      },
                                    }),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.shop.info.AndroidApp
                            ? _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      title: "Télecharger sur Google Play",
                                      href:
                                        "https://" + _vm.shop.info.AndroidApp,
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        alt: "Télecharger sur Google Play",
                                        src: require("../_design_files/img/download-android.png"),
                                        width: "173",
                                        height: "58",
                                      },
                                    }),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "blockFooter social" }, [
                  _c("h4", [_vm._v("Suivez nous")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-start align-items-center",
                    },
                    [
                      _c("ul", [
                        _vm.shop.Facebook
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://" + _vm.shop.Facebook,
                                    target: "_blank",
                                  },
                                },
                                [_vm._m(0)]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shop.Instagram
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://" + _vm.shop.Instagram,
                                    target: "_blank",
                                  },
                                },
                                [_vm._m(1)]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shop.Twitter
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://" + _vm.shop.Twitter,
                                    target: "_blank",
                                  },
                                },
                                [_vm._m(2)]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shop.info.TripAdvisor
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://" + _vm.shop.info.TripAdvisor,
                                    target: "_blank",
                                  },
                                },
                                [_vm._m(3)]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid copyBlock" }, [
        _c("div", { staticClass: "alignBox" }, [
          _c("div", { staticClass: "copy" }, [
            _c("a", { attrs: { href: "https://www.clyosystems.com" } }, [
              _vm._v("Caisse Enregisteuse"),
            ]),
            _vm._v(
              "\n\t\t\t© " +
                _vm._s(_vm.year) +
                " Eatself. Tous droits réservés\n\t\t"
            ),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass: "horz",
              staticStyle: {
                display: "inline-block",
                float: "right",
                "margin-top": "-37px",
              },
            },
            [
              !_vm.user
                ? _c("li", { staticClass: "pull-right" }, [_vm._m(4)])
                : _vm._e(),
              _vm._v(" "),
              _vm.user
                ? _c("li", { staticClass: "pull-right" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn-group adminMenu dropup",
                        attrs: { xstyle: "display: block" },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-toggle user",
                            attrs: { "data-toggle": "dropdown", xhref: "" },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "Fname",
                                staticStyle: { "font-size": "12px" },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      (_vm.shop && _vm.shop.DefaultName) ||
                                        "Shop Name"
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "caret" }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "dropdown-menu dropdown-menu-right" },
                          [
                            _vm._m(5),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.editOptionGroups()
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "icone icone-lab" }),
                                  _c("span", [_vm._v("Groupes d'options")]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._m(6),
                            _vm._v(" "),
                            _vm._m(7),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: { href: _vm.user.ShopId + "/carte/0" },
                                },
                                [
                                  _c("i", { staticClass: "icone icone-shop" }),
                                  _c("span", [_vm._v("Passer commande")]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: { href: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.logout()
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "clyo clyo-disconect",
                                  }),
                                  _c("span", [_vm._v("Déconnecter")]),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-stack" }, [
      _c("i", { staticClass: "fa fa-square fa-stack-2x" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-facebook fa-stack-1x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-stack" }, [
      _c("i", { staticClass: "fa fa-square fa-stack-2x" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-instagram fa-stack-1x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-stack" }, [
      _c("i", { staticClass: "fa fa-square fa-stack-2x" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-twitter fa-stack-1x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-stack" }, [
      _c("i", { staticClass: "fa fa-square fa-stack-2x" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-tripadvisor fa-stack-1x" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "admin-login" } }, [
      _c("span", { staticClass: "fa-stack fa-lg" }, [
        _c("i", { staticClass: "fa fa-circle-thin fa-stack-2x" }),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-key fa-stack-1x" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "admin/profile" } }, [
        _c("i", { staticClass: "clyo clyo-gear" }),
        _c("span", [_vm._v("Paramètres")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "admin/orders" } }, [
        _c("i", { staticClass: "icone icone-new-commande" }),
        _c("span", [_vm._v("Historique des commandes")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "admin/carte/0" } }, [
        _c("i", { staticClass: "icone icone-editer" }),
        _c("span", [_vm._v("Editer la carte")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }